module.exports = __webpack_public_path__ + "media/img/room-icon-39631b6f47ef995b157b739babdb729e.png";